// extracted by mini-css-extract-plugin
export default {"content":"Service_content__vuHyL"};